import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-flipping-cards-for-positive-communication-rw',
  templateUrl: './page-activity-flipping-cards-for-positive-communication-rw.component.html',
  styleUrls: ['./page-activity-flipping-cards-for-positive-communication-rw.component.css', '../module-page-rw/module-page-rw.component.css']
})
export class PageActivityFlippingCardsForPositiveCommunicationRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  cards = 8;

  flipped = {
    all:  false,
    card: this.generate(this.cards, false),
  };

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  private generate(count: number, value: boolean) {
    const array = new Array(count).fill(value);
    return array;
  }

  all<T = unknown>(array: T[], value: T) {
    return array.every(v => v === value);
  }

  allOf(obj: Object, value = true) {
    return this.all(Object.values(obj), value);
  }
}
